import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx as cx } from 'clsx';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { CheckboxSucess12 } from '../../../prev/icons';
import { useDeviceType } from '../../../responsive';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CheckboxComponent = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
  var disabled = props.disabled,
    invalid = props.invalid,
    label = props.label;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  return /*#__PURE__*/_jsxs(ControlInputContainer, _objectSpread(_objectSpread({}, props), {}, {
    type: "checkbox",
    className: cx(styles['checkbox'], disabled && styles['disabled'], invalid && styles['invalid'], !!label && styles['hasLabel']),
    ref: ref,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles['box'],
      children: /*#__PURE__*/_jsx(CheckboxSucess12, {
        color: "current_color"
      })
    }), label && /*#__PURE__*/_jsx("span", {
      className: styles['label'],
      children: label
    })]
  }));
});

/**
 * Компонент простого чекбокса с лейблом
 *
 * На телефоне имеет блочный дизайн и чекбокс справа
 *
 * @export
 * @param {ICheckboxProps} props
 * @returns
 */
export var Checkbox = /*#__PURE__*/React.memo(CheckboxComponent);